<div class="container">
  <icn-graphics-media-item
    class="media-item"
    *ngFor="let media of mediaFields"
    [media]="media"
    (dynamicOptionsToggle)="onDynamicClick($event, media)"
    (linkOptionToggle)="onLinkClick($event, media)"
    [isCurrent]="editedMedia && editedMedia.id === media.id"
    (click)="editedMedia = media; markForCheck()"
  >
  </icn-graphics-media-item>
</div>
<div class="border"></div>
<div class="media-options" *ngIf="!!editedMedia">
  <div class="label">FIT MEDIA:</div>
  <div class="fit-media-dropdown">
    <icn-dropdown
      [large]="true"
      [selectedValue]="editedMedia.fitMedia"
      (selectedValueChange)="
        editedMedia.fitMedia = $event; markForCheck()
      "
    >
      <icn-dropdown-item
        [title]="'Ignore Aspect'"
        [value]="1"
      ></icn-dropdown-item>
      <icn-dropdown-item [title]="'Letterbox'" [value]="2"></icn-dropdown-item>
      <icn-dropdown-item
        [title]="'Stretch to Cover'"
        [value]="3"
      ></icn-dropdown-item>
    </icn-dropdown>
  </div>
</div>
<div class="media-options" *ngIf="editedMedia && editedMedia.mediaType === 3">
  <div class="label">LINK TO:</div>
  <input
    type="text"
    placeholder="Add a Dropbox or Google Drive Link"
    [ngModel]="editedMedia.link"
    (ngModelChange)="
      editedMedia.link = $event; markForCheck()
    "
  />
  <icn-dropdown
    [ngStyle]="{ 'line-height': '29px' }"
    [short]="true"
    [selectedValue]="editedMedia.imageOrVideo"
    (selectedValueChange)="
      editedMedia.imageOrVideo = $event; markForCheck()
    "
  >
    <icn-dropdown-item [title]="'Image'" [value]="1"></icn-dropdown-item>
    <icn-dropdown-item [title]="'Video'" [value]="2"></icn-dropdown-item>
  </icn-dropdown>
</div>
<div class="media-options" *ngIf="editedMedia && editedMedia.mediaType === 2">
  <icn-text-dynamic-options
    (dynamicOptionClick)="insertDynamicField($event)"
    type="media"
  >
  </icn-text-dynamic-options>
</div>
